
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  data() {
    return {
      activeIndexImage: null,

      // Swiper
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      active: 0,
    };
  },

  components: {
    Swiper,
    SwiperSlide,
    CoolLightBox,
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    productImage: function () {
      return this.product.imageId;
    },

    productImages: function () {
      return this.product?.imageIds || [];
    },

    isShowSlider: function () {
      return Boolean(this.productImages.length > 1);
    },

    imagesCoolLightBox() {
      return (this.productImages).map((imageId) => this.$img(imageId.toString(), { width: 1900 }));
    },
    currentCity() {
      return this.$store?.state?.appState?.config?.city?.data?.prepositional || 'Екатеринбурге';
    },
    productNameForSeo() {
      return `${this.product.name || ''}-${this.product.code || ''} в ${this.currentCity}`;
    },
  },

  methods: {

    setIdxForGallery(idx) {
      this.activeIndexImage = idx;
    },

    slideChangeTransitionEnd: function () {
      const activeIndex = this.$refs?.productSliderImages?.swiperInstance?.activeIndex || 0;

      this.active = activeIndex;
    },
    slideSetIndex: function (index) {
      this.$refs?.productSliderImages?.swiperInstance?.slideTo(index);
    },
  },
};
